import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { NewUserEducationModal } from 'src/new-user-education-modal/NewUserEducationModal';
import { ExploreTabNames } from 'src/pages/consumer/dish-first/explore/ExplorePage/consts';
// Please keep HelpButtonComponent import explicit. It avoids a potential circular dependency
import { HelpButtonComponent } from 'src/shared/design-system/HelpButton/HelpButtonComponent';
// Please keep useHelpButtonState import explicit. It avoids a potential circular dependency
import { useHelpButtonState } from 'src/shared/design-system/HelpButton/helpButtonState';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useModal } from 'src/shared/hooks/useModal';
import { Routes } from 'src/shared/Routes';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { StringParam, useQueryParam } from 'use-query-params';

export const NewUserEducationModalHelpButton: React.FC = () => {
  const { isShowing, show, hide } = useModal();
  const { setHasSeenNewUserEducationModal } = useHelpButtonState();
  const location = useLocation();

  const [tab] = useQueryParam(QueryParams.TAB, StringParam);
  const isWeeklyShefServiceTab =
    locationInRoutes(location, [Routes.CONSUMER_EXPLORE]) && tab === ExploreTabNames.ShefService;

  const isBlocklistedPage =
    locationInRoutes(location, [
      Routes.CONSUMER_MEAL_PLANS,
      Routes.CONSUMER_MEAL_PLANS_CHECKOUT,
      Routes.CONSUMER_MEAL_PLANS_PREFERENCES,
      Routes.CONSUMER_MEAL_PLANS_CHECKOUT,
      Routes.CONSUMER_MEAL_PLANS_EDIT_ORDER,
    ]) || isWeeklyShefServiceTab;

  const onHide = useCallback(() => {
    setHasSeenNewUserEducationModal(true);
    hide();
  }, [setHasSeenNewUserEducationModal, hide]);

  if (isBlocklistedPage) return null;

  return (
    <>
      <HelpButtonComponent onClick={show} label='How it Works' />
      <NewUserEducationModal isShowing={isShowing} onHide={onHide} />
    </>
  );
};
